var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.37259 4.61765H11.9608M5.37259 7.91176H10.3138M13.6079 0.5C14.2631 0.5 14.8915 0.760293 15.3549 1.22362C15.8182 1.68694 16.0785 2.31535 16.0785 2.97059V9.55882C16.0785 10.2141 15.8182 10.8425 15.3549 11.3058C14.8915 11.7691 14.2631 12.0294 13.6079 12.0294H9.49024L5.37259 14.5V12.0294H3.72553C3.07029 12.0294 2.44189 11.7691 1.97856 11.3058C1.51524 10.8425 1.25494 10.2141 1.25494 9.55882V2.97059C1.25494 2.31535 1.51524 1.68694 1.97856 1.22362C2.44189 0.760293 3.07029 0.5 3.72553 0.5H13.6079Z",
    stroke: "var(--brand-color)",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatRed);
export default __webpack_public_path__ + "static/media/chat-red.f4598066f05d83a9007cbbb8b12fece1.svg";
export { ForwardRef as ReactComponent };